import useSWRInfinite from 'swr/infinite';

import { buildUrl, InsightsApi } from 'src/api/Api';
import { PatientExercice } from 'src/domain/patient/Patients';

const PATIENT_EXERCISE = (patientId: string) => `/patients/${patientId}/exercise`;

export function usePatientExercise(patientId: string) {
  const {
    data = [],
    error,
    isValidating,
    size,
    setSize,
  } = useSWRInfinite(
    getKey,
    (_url) =>
      InsightsApi.get<{ exerciseData: PatientExercice[] }>(_url).then(
        ({ exerciseData }) => exerciseData
      ),
    { revalidateOnFocus: false }
  );

  return {
    isLoading: isValidating,
    exerciseData: data.flat(),
    error,
    fetchMore() {
      setSize(size + 1);
    },
  };

  function getKey(page: number, previousPageData: PatientExercice[]) {
    if (previousPageData && !previousPageData.length) return null; // reached the end

    return (
      patientId &&
      buildUrl(PATIENT_EXERCISE(patientId), {
        page: page + 1,
        pageSize: 7,
      })
    );
  }
}
